import Style from "../../../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import FieldsInput from "../../../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Layout from "../../../../../../styles/Layout.styles";

const LocationShortCode = (props) => {
  const { locationShortCode } = props;
  const style = Style();
  const layout = Layout;
  const { t } = useTranslation();
  return (
    <>
      <Stack className={mergeClasses(layout.textbox, layout.mb_1)}>
        <FieldsInput
          label={t("project.pl_short_code")}
          fieldClassName="custom-label"
          validationMessage={props?.errors?.locationShortCode?.message}
          placeholder={t("project.pl_enter_short_code")}
          name="locationShortCode"
          id="locationShortCode"
          inputClassName={style.textboxInput}
          inputDefaultValue={locationShortCode}
          validation={props.register("locationShortCode", {
            required: `${t("validation_message.shortcode_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default LocationShortCode;
